<script>

    import ModalEdit from '../../../layouts/ModalEdit.vue';

    export default {
        extends: ModalEdit,
        name: 'modal',
        props: ['value','visible'],
        data: function () {
            return {
              config: null,
              internalValue: '',
            }
        },
        mounted: function(){

        },
        created: function(){
          this.internalValue = this.value;

          this.initialize();
        },
        methods: {
          close() {
            this.$emit('close');
          },
          validate(){
            this.$emit('validate');
          },
        },
        watch: {
          'value'(newVal, oldVal) {
            this.internalValue = newVal
          }
        }
    };

</script>
<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" v-bind:class="className">
      <div class="modal-overlay" @click="close()"></div>
      <div class="modal"
           role="dialog"
           aria-labelledby="modalTitle"
           aria-describedby="modalDescription">
        <article v-if="internalValue && internalValue.data">
          <header
              class="modal-header"
              id="modalTitle">
            <figure><i class="icon icon-icon_file-edit"></i></figure>
            <div>
                <span class="breadcrumb">
                    Collection <i class="icon icon-icon_arrow-right"></i> Edit
                </span>
                <h1>Collection</h1>
            </div>
            <div class="spacer"></div>
            <div class="buttons">
              <button @click="close()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
              <button @click="validate()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
            </div>
          </header>
          <main>

            <languages :translations="internalValue.data.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

              <tabs :options="{ useUrlFragment: false }">
                  <tab name="Information">

                    <fieldset>
                      <h3>Détail de la collection</h3>
                      <p class="headline"></p>

                      <form-toggle label="Published" v-model="internalValue.data.publication_state_id"></form-toggle>

                      <form-file label='Image' v-model="internalValue.data.picture_id" width="200"></form-file>

                      <form-text :label="'Slug'" v-model="internalValue.data.slug" :required="true"></form-text>

                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                          <form-text :translate-key="'name'" :translations="internalValue.data.translations" :lang="client.id" :label="'Nom'" v-model="internalValue.data.translations[client.id].name" :required="true"></form-text>
                        </div>
                      </div>

                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                          <form-text :translate-key="'name'" :translations="internalValue.data.translations" :lang="client.id" :label="'Headline'" v-model="internalValue.data.translations[client.id].headline" :required="true"></form-text>
                        </div>
                      </div>

                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                          <form-text :translate-key="'name'" :translations="internalValue.data.translations" :lang="client.id" :label="'Description'" v-model="internalValue.data.translations[client.id].description" :required="true"></form-text>
                        </div>
                      </div>

                    </fieldset>


                  </tab>
                  <tab name="Seo">

                    <fieldset>
                      <h3>SEO</h3>
                      <p class="headline">Optimiser l'affichage de votre produit dans la recherche Google.</p>

                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                          <form-text :translate-key="'name'" :translations="internalValue.data.translations" :lang="client.id" :label="'Meta URL'" v-model="internalValue.data.translations[client.id].meta_url" :required="true"></form-text>
                        </div>
                      </div>

                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                          <form-text :translate-key="'name'" :translations="internalValue.data.translations" :lang="client.id" :label="'Meta Title'" v-model="internalValue.data.translations[client.id].meta_title" :required="true"></form-text>
                        </div>
                      </div>

                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                          <form-text :translate-key="'name'" :translations="internalValue.data.translations" :lang="client.id" :label="'Meta Description'" v-model="internalValue.data.translations[client.id].meta_description" :required="true"></form-text>
                        </div>
                      </div>

                    </fieldset>

                  </tab>
              </tabs>

          </main>
        </article>
      </div>
    </div>
  </transition>
</template>


// WEBPACK FOOTER //
// src/modules/shop/brand/Modal.vue